<template>
  <v-list>
    <v-subheader class="settings-header">Beállítások</v-subheader>
    <v-list-item-group color="primary">
      <v-list-item>
        <s-switch label="Sötét mód" leftLabel="Igen" rightLabel="Nem" @onvaluechange="darkmodeChanged" :switched="darkmode"/>
      </v-list-item>

      <v-list-item v-if="!isRoute('dmr')">
        <s-switch label="Gyors gombok" leftLabel="Igen" rightLabel="Nem" @onvaluechange="hotkeyChanged" :switched="hotkeys"/>
      </v-list-item>

      <v-list-item v-if="isRoute('report')" :disabled="!canChangeScreen">
        <s-switch label="Egyszerűsített felület" leftLabel="Igen" rightLabel="Nem" @onvaluechange="basicChangedSync" :switched="basic" :disabled="!canChangeScreen"/>
      </v-list-item>

      <v-list-item v-if="!isRoute('dmr')" @click="mirrorChanged">
        <span class="settings-label little-text">Térfélcsere</span>
      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>

<script>
//var debug = require('debug')('MKSZ:Settings');
import SSwitch from "@/components/SSwitch";
import Stepper from "@/components/Stepper";
import eventBus from '@/eventBus';
import CONSTANTS from '@/constants';
import { mapState } from 'vuex';

import busListeners from "@/mixins/busListeners";

export default {
    mixins: [busListeners],
  name: "SSettings",
  components: {
    SSwitch: SSwitch,
    Stepper: Stepper,
  },
  props: {
    darkmode: Boolean,
    hotkeys: Boolean,
    gamedata: Object
  },
  data() {
    return {
      autosave: !this.isRoute('dmr'),
      saveTime: 0,
      mirror: false,
      basic: false,
      // canChangeScreen TÖRÖLVE innen, mert computed lett a dinamikus figyeléshez
    };
  },
  computed: {
    // Bekötjük a timelineData-t a Store-ból a reaktivitás miatt
    ...mapState('game', ['timelineData']),

    // Az ERP (a verseny szintje) BŐVÍTETT jegyzőkönyvet ír-e elő. Ilyenkor a
    // nézet nem állítható egyszerűsítettre - sem kapcsolóval, sem a mérkőzés
    // adataiból visszajátszott korábbi beállításból.
    //
    // Szigorúan `=== false`-t nézünk: ha az `erpBasic` hiányzik (régebbi, a
    // mező bevezetése előtt indult mérkőzés) vagy `undefined`, NEM korlátozunk,
    // nehogy egy hiányzó mező miatt zárjuk ki a szabályos váltást.
    isExtendedMandated() {
      if (!this.gamedata) return false;
      if (this.gamedata.rule === 'STRAND') return false;
      const erp = typeof this.gamedata.erpBasic !== "undefined"
          ? this.gamedata.erpBasic
          : this.gamedata.basic;
      return erp === false;
    },

    canChangeScreen() {
      // Ha Strand kézilabda, akkor alapból nem válthat (kényszerített basic)
      if (this.gamedata && this.gamedata.rule === 'STRAND') {
        return false;
      }

      // Ha a verseny szintje bővítettet ír elő (pl. NB I), a kapcsoló tiltva van:
      // innen LEFELÉ (egyszerűsítettre) váltani nem szabad. Ezt korábban semmi nem
      // akadályozta - l. a 32021422896 (Budai Farkasok-Rév - Csurgói KK) mérkőzést,
      // ahol a jegyzőkönyvvezető az első esemény előtt 59 másodperccel átkapcsolt
      // egyszerűsítettre, és az egész NB I-es mérkőzés úgy ment végig.
      if (this.isExtendedMandated) {
        return false;
      }

      // Megszámoljuk a valódi eseményeket
      let actualEventNumbers = 0;

      // Elsőbbséget élvez a Store-ból jövő timelineData
      const eventsToCheck = this.timelineData || (this.gamedata ? this.gamedata.timelineData : []);

      if (eventsToCheck && eventsToCheck.length > 0) {
        eventsToCheck.forEach(function (item) {
          if(!item.deleted && item.action !== "gamedatachange" && item.action !== "init") {
            actualEventNumbers++;
          }
        });
      }

      // Ha nincs valódi esemény (0), akkor engedélyezzük a váltást (true)
      return actualEventNumbers === 0;
    }
  },
  mounted() {
    let self = this;

    window.dbmanager.getConfig('autosave').then((result) => {
      if (typeof result === "undefined" || result === null) {
        self.autosave = true;
        window.dbmanager.setConfig({name: 'autosave', value: self.autosave});
      } else {
        self.autosave = result.value;
      }

      window.autosave = self.autosave;
    });

    window.dbmanager.getConfig('saveTime').then((result) => {
      if (typeof result === "undefined" || result === null) {
        self.saveTime = 0;
        window.dbmanager.setConfig({name: 'saveTime', value: self.saveTime});
      } else {
        self.saveTime = result.value;
      }

      window.saveTime = self.saveTime;
    });

    // Basic mode local config betöltése
    window.dbmanager.getConfig('basic').then((result) => {
      if (typeof result !== "undefined" && result !== null) {
        self.basic = result.value;
      }
    });

    this.$busOn(CONSTANTS.EVENTS.CHANGE.GAMEDATALOADED, function() {
      // 1. Strand kézilabda kezelése: Mindig BASIC
      if (self.gamedata && self.gamedata.rule === 'STRAND') {
        if (!self.basic) {
          self.basic = true;
          self.basicChanged(true);
        }
        return;
      }

      // 1/b. Ha az ERP bővítettet ír elő, a nézetet KÉNYSZERÍTJÜK bővítettre.
      // Fontos, hogy ez az ág a lenti `!canChangeScreen` korai kilépés ELŐTT
      // fusson: a `basic` beállítás eszköz-szintű, helyi konfigból (IndexedDB)
      // töltődik, tehát egy KORÁBBI, alacsonyabb osztályú mérkőzésről ottmaradt
      // `basic: true` áthúzódhat erre a mérkőzésre is. A korai kilépés ilyenkor
      // pont azt az elavult helyi értéket hagyná érvényben.
      if (self.isExtendedMandated) {
        if (self.basic) {
          self.basic = false;
          self.basicChanged(false, true);
        }
        window.dbmanager.setConfig({name: 'basic', value: false});
        window.basic = false;
        return;
      }

      // 2. JAVÍTÁS: Ha már vannak események (!canChangeScreen),
      // NE írjuk felül a beállítást a gamedata alapértelmezéssel!
      if (!self.canChangeScreen) {
        console.log("Settings: Események vannak, a nézet rögzítve marad.");
        return;
      }

      // 3. Ha még nincs esemény, akkor átvehetjük a szerverről jött értéket
      let result = self.gamedata ? self.gamedata.basic : undefined;
      if (typeof result === "undefined") {
        self.basicChanged(false);
      } else {
        self.basicChanged(result);
      }

      window.dbmanager.setConfig({name: 'basic', value: self.basic});
      window.basic = self.basic;
    });

    this.$busOn(CONSTANTS.EVENTS.CHANGE.SCREENMODE, function(canChange) {
      // A computed property ezt most már dinamikusan kezeli,
      // de meghagyhatjuk, ha külső komponens kényszeríteni akarja.
      // self.canChangeScreen = self.basic || canChange;
    });
  },
  methods: {
    autosaveChanged(value) {
      this.autosave = value;
      window.autosave = value;
      window.dbmanager.setConfig({name: 'autosave', value: value});
    },
    saveTimeChanged(value) {
      this.saveTime = value;
      window.saveTime = value;
      window.dbmanager.setConfig({name: 'saveTime', value: value});
    },
    hotkeyChanged(value) {
      window.dbmanager.setConfig({name: 'hotkeys', value: value});
      eventBus.$emit(CONSTANTS.EVENTS.CHANGE.HOTKEYS, value);
    },
    darkmodeChanged(value) {
      window.dbmanager.setConfig({name: 'darkmode', value: value});
      eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DARKMODE, value);
    },
    mirrorChanged() {
      //debug("mirror changed emit!");
      this.mirror = !this.mirror;
      eventBus.$emit(CONSTANTS.ACTIONS.TOGGLE.DIRECTION);
      eventBus.$emit(CONSTANTS.EVENTS.MIRROR, this.mirror);
    },
    basicChanged(value, force) {
      // Itt is ellenőrizzük a feltételt a biztonság kedvéért.
      // A `force` a KÉNYSZERÍTETT (nem felhasználói) beállításokhoz kell - ilyenkor
      // a `canChangeScreen` szándékosan false (pl. bővítettet előíró versenyen),
      // mégis be KELL állítanunk a helyes értéket.
      if(force || this.canChangeScreen || (this.gamedata && this.gamedata.rule === 'STRAND')) {
        this.basic = value;
        window.dbmanager.setConfig({name: 'basic', value: this.basic});
        eventBus.$emit(CONSTANTS.EVENTS.BASICMODECHANGED, value);
      }
    },
    basicChangedSync(value) {
      // Ha nem válthat, visszaállítjuk a kapcsolót (UI védelem)
      if (!this.canChangeScreen) {
        this.$forceUpdate();
        return;
      }

      // Kettős védelem: a `canChangeScreen` már tiltja a kapcsolót, ha a verseny
      // szintje bővítettet ír elő, de ez az ág az egyetlen hely, ahol a váltás
      // ténye a mérkőzés adatai közé is BEÍRÓDIK (`gamedatachange`, l. lent) -
      // ezért itt is kizárjuk, nehogy egy jövőbeli UI-változás megkerülje.
      if (value === true && this.isExtendedMandated) {
        this.basic = false;
        this.$forceUpdate();
        return;
      }

      window.dbmanager.write({
        action: 'gamedatachange',
        params: {
          name: 'basic',
          value: value
        }
      });

      this.basicChanged(value);
    },
    isRoute(url){
      return this.$route.meta.header === url;
    },
  }
};
</script>

<style scoped>
.settings-header {
  font-size: 16px;
  font-weight: bold;
  font-stretch: condensed;
  font-family: 'Roboto Condensed';
}

.mirrorLabel {
  padding: 0 !important;
  height: 48px !important;
  font-size: 14px !important;
  width: 100%;
  justify-content: flex-start;
  font-weight: normal;
}

.little-text {
  font-size: 14px;
}
</style>

<style>
.mirrorLabel .v-btn__content {
  text-transform: none;
  letter-spacing: normal;
  text-indent: 0;
}
</style>
